import { Grid, Paper, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
import { Controller, useForm } from "react-hook-form";

import { NonNullableItemState } from "../../redux/state";

import { Select } from "@ofqual/portal-components/components/Select";
import { InformationRequest } from "../../domain/InformationRequest";

import { useLookup } from "@ofqual/portal-core/core/hooks";
import { requestSubTypeLookupService, requestTypeLookupService } from "../../services";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { MarkdownEditor } from "@ofqual/portal-components/components/MarkdownEditor";
import { fieldLabels } from "./fieldLabels";
import { Permissions } from "./permissions/Permissions";
import { RecipientOrg } from "../../domain/RecipientsViewModel";
import { ExperimentalFeature } from "@ofqual/portal-components/components/ExperimentalFeature";
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";

const useStyles = makeStyles((theme) => ({
  formSection: {
    padding: 30,
    boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    borderRadius: "3px",
  },
  infoIcon: {
    margin: 10,
    fontSize: "2em",
  },
}));

type FormProps = {
  state: NonNullableItemState;
  recipientOrg: RecipientOrg;
  roles: string[];
};

export const Form: React.FC<FormProps> = ({ state, recipientOrg, roles }) => {
  const { item } = state;

  const { control } = useForm<InformationRequest>({
    defaultValues: item,
  });

  const [requestTypeLookups, requestSubTypeLookups] = useLookup(requestTypeLookupService, requestSubTypeLookupService);
  const classes = useStyles();

  const { experimentalFeatures } = useSelector(authSelector);
  
  return (
    <>
      <form>
        <Typography variant="h6">Message Details</Typography>
        <Paper className={classes.formSection}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="requestType"
                as={
                  <Select
                    label={fieldLabels.requestType}
                    readOnly
                    data-test="cao-requestType"
                  >
                    {requestTypeLookups}
                  </Select>
                }
              />
            </Grid>
            <ExperimentalFeature
              experimentalModuleName="portal-comms-cao"
              experimentalFeatures={experimentalFeatures}
              experimentalFeatureVisibleName="cao-request-sub-type-ao"
            >
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="requestSubType"
                  as={
                    <Select
                      label={fieldLabels.requestSubType}
                      readOnly
                      data-test="cao-requestSubType"
                    >
                      {requestSubTypeLookups}
                    </Select>
                  }
                />
              </Grid>
            </ExperimentalFeature>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="subject"
                as={
                  <TextField
                    label={fieldLabels.subject}
                    readOnly
                    multiline
                    data-test="cao-subject"
                  />
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="message"
                render={({ onChange, value }) => (
                  <>
                    <MarkdownEditor
                      onChange={onChange}
                      value={value}
                      readOnly
                    />
                  </>
                )}
              />
            </Grid>
          </Grid>
        </Paper>
        <Permissions
          recipientOrg={recipientOrg}
          id={item.id}
          roles={roles}
          allowReassignment={item.allowAoReassignment}
        />
      </form>
    </>
  );
};
